export const config = {
    "Ducato": {
        "displayname" : "Ducato",
        "carsize": "Van",
        "url": "https://assets.fcaab.com.au/assets-public/forms/fiat/Ducato.jpg",
        "alt": "", cta: {
            "features": "https://www.fiat.com.au/ducato.html",
            "offers": "https://www.fiat.com.au/offers/offers-ducato.html",
            "testdrive": "https://www.fiat.com.au/request-a-test-drive-cv.html?vehicle=Ducato&year=2018",
            "brochure": "https://www.fiat.com.au/request-a-brochure-cv.html?vehicle=Ducato&year=2018",
            "quote" : "https://www.fiat.com.au/request-a-quote-cv.html?vehicle=Ducato&year=2018",
            "specs" : "https://www.fiat.com.au/content/dam/cross-regional/apac/fiat/en_au/request-a-brochure/pdfs/FIAT_DUCATO_Brochure.pdf",
        },
        "year" : "2018"
        ,
        images: [
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/portrait/Ducato.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/portrait/Ducato.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/landscape/Ducato.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/landscape/Ducato.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/landscape/Ducato.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/landscape/Ducato.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/portrait/Ducato.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/portrait/Ducato.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/desktop/Ducato.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/desktop/Ducato.jpg 2x"

        ]

    },
    "Scudo": {
        "displayname" : "Scudo",
        "carsize": "Van",
        "url": "https://assets.fcaab.com.au/assets-public/forms/fiat/Scudo.jpg",
        "alt": "", cta: {
            "features": "https://www.fiat.com.au/scudo.html",
            "offers": "https://www.fiat.com.au/offers/offers-scudo.html",
            "testdrive": "https://www.fiat.com.au/request-a-test-drive-cv.html?vehicle=Scudo&year=2018",
            "brochure": "https://www.fiat.com.au/request-a-brochure-cv.html?vehicle=Scudo&year=2018",
            "quote" : "https://www.fiat.com.au/request-a-quote-cv.html?vehicle=Scudo&year=2018",
            "specs" : "https://www.fiat.com.au/content/dam/cross-regional/apac/fiat/en_au/request-a-brochure/pdfs/FIAT_SCUDO_Brochure.pdf",
        },
        "year" : "2018"
        ,
        images: [
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/portrait/Scudo.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/portrait/Scudo.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/mobile/landscape/Scudo.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/mobile/landscape/Scudo.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/landscape/Scudo.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/landscape/Scudo.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/tablet/portrait/Scudo.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/tablet/portrait/Scudo.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/fiat/1x/desktop/Scudo.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/fiat/2x/desktop/Scudo.jpg 2x"

        ]

    },
    models : [
        'Ducato',
        'Scudo',
    ],
    privacypolicy : "https://www.fiat.com.au/privacy.html",
    ra : "https://www.fiat.com.au/roadside-assistance.html",
    "compPrivacypolicy" : "https://www.fiat.com.au/privacy.html",
    brochureSentByEmail: true,
    virtualtestdrivedealers : [
    ],


};
